<div class="header-container">
  <div class="d-inline-flex">
    <div class="nav-links">
      <ul>
        <li>
          <div class="header-menu">
            <div class="menu-header-content no-menu icon-only px-0" (click)="navigateToExternalURL(linkHome)">
              <mwp-svg-icon [SvgMatType]="svgType.Home"/>
            </div>
          </div>
        </li>
      </ul>
    </div> 
    <div class="header-divider mx-3">
    </div>
    <div class="nav-links">
      <ul>
        <li>
          <div class="header-menu" [ngClass]="isHeaderLinkActive(memberLink)? 'active-link' : ''">
            <div class="menu-header-content no-menu fw-bold" (click)="navigateToURL(memberLink)">
              <mwp-text-translate text="Members" jsonKey="members" />
            </div>
          </div>
        </li>
        <li>
          <div class="header-menu">
            <div class="menu-header-content no-menu fw-bold" (click)="navigateToExternalURL(linkAdministrators)">
              <mwp-text-translate text="Administrators" jsonKey="administrators" />
            </div>
          </div>
        </li>
        <li>
          <div class="header-menu" [ngClass]="isHeaderLinkActive(linkCounselors)? 'active-link' : ''">
            <div class="menu-header-content no-menu fw-bold" (click)="navigateToURL(linkCounselors)">
              <mwp-text-translate text="Benefit Counselors" jsonKey="benefitCounselors" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="settings-icon-container">
    @if (operatingMode) {
      <div class="operating-mode d-inline-flex">
        <mwp-svg-icon [SvgMatType]="svgType.Wrench" />
        <div class="fw-bold ms-1">
          {{ operatingMode }}
        </div>
      </div>
    }
  </div>
</div>